import dayjs from 'dayjs';
import i18next from 'i18next';

const getCurrentLang = (): 'ko' | 'en' => {
  const lang = i18next.language;
  return lang.startsWith('en') ? 'en' : 'ko';
};

/**
 * timestamp로부터 현재까지 경과한 시간을 "x개월 x주 x일 x시간 x분" 형태로 반환
 * 언어에 따라 단위도 번역됨
 */
export const findAgoFromNow = (timestamp: number): string => {
  const now = dayjs();
  const past = dayjs(timestamp);
  const lang = getCurrentLang();

  const units = {
    month: lang === 'en' ? 'm' : '개월',
    week: lang === 'en' ? 'wk' : '주',
    day: lang === 'en' ? 'd' : '일',
    hour: lang === 'en' ? 'h' : '시간',
    minute: lang === 'en' ? 'min' : '분',
  };

  const totalDiffInMonths = now.diff(past, 'month');
  const pastWithMonthsAdded = past.add(totalDiffInMonths, 'month');
  const remainingMinutes = now.diff(pastWithMonthsAdded, 'minute');

  const weeks = Math.floor(remainingMinutes / (60 * 24 * 7));
  const days = Math.floor((remainingMinutes % (60 * 24 * 7)) / (60 * 24));
  const hours = Math.floor((remainingMinutes % (60 * 24)) / 60);
  const minutes = remainingMinutes % 60;

  const parts = [];
  if (totalDiffInMonths) parts.push(`${totalDiffInMonths}${units.month}`);
  if (weeks) parts.push(`${weeks}${units.week}`);
  if (days) parts.push(`${days}${units.day}`);
  if (hours) parts.push(`${hours}${units.hour}`);
  if (minutes || parts.length === 0) {
    parts.push(`${minutes}${units.minute}`);
  }

  return parts.join(' ');
};
